/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
// nothing yet

/**
 *     @section 2. Class
 */
class Copyright {
    constructor() {
        // toggle open class on click
        document.querySelectorAll('.copyright__button').forEach((buttonEl) => {
            buttonEl.addEventListener('click', () => {
                buttonEl.closest('.copyright')?.classList.toggle('open')
            })
        })

        // close on click outside
        document.addEventListener('click', (event) => {
            const target = event.target as HTMLElement
            const copyrightEl = document.querySelector('.copyright.open')
            if (copyrightEl && !copyrightEl.contains(target)) {
                copyrightEl.classList.remove('open')
            }
        })
    }
}

/**
 *     @section 3. Export class
 */

export default new Copyright()

// end of copyright.ts file
